import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IListState, ISagaCb, PaginationType } from '@typings/requestPayloads'

export interface IListSearchSharedListPayload extends ISagaCb {
    pagination?: PaginationType
    needPopulate?: boolean
    populates?: any[]
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: [],
    pagination: {
        skip: 0,
        hasTotal: true,
        total: 0,
        limit: 10
    },
    errors: null
}

const listSearchSharedList = createSlice({
    name: 'sharedList/list-search',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IListSearchSharedListPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload.data
            state.pagination = {
                ...state.pagination,
                skip: action.payload.skip,
                total: action.payload.total
            }
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const listSearchSharedListActions = listSearchSharedList.actions
export default listSearchSharedList.reducer
